import { render, staticRenderFns } from "./MailWhite.vue?vue&type=template&id=daba06d8&scoped=true"
var script = {}
import style0 from "./MailWhite.vue?vue&type=style&index=0&id=daba06d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daba06d8",
  null
  
)

export default component.exports